module.exports = __webpack_public_path__ + "img/abc-cover.52d3b24e.png";